module.exports = __webpack_public_path__ + "media/images/views/home/home-section-quem-somos-3eec89d895cb4622cb28b18be80bcad6.png";